import constate from 'constate';
import { useAudioTrackContext } from './audio-track.provider';

const useProvider = () => {
  const { ws } = useAudioTrackContext();

  const removeMarkers = (markers: Index[]) => {
    if (!ws.current) return;
    const list = ws.current.regions.list;
    markers.forEach((id) => list[id].remove());
  };

  const moveMarker = (markerId: Index, position: number) => {
    if (!ws.current) return;
    const list = ws.current.regions.list;
    const marker = list[markerId];
    const dur = marker.end - marker.start;
    marker.update({ start: position, end: position + dur });
  };

  return { removeMarkers, moveMarker };
};

export const [WsMarkersProvider, useWsMarkersContext] = constate(useProvider);
